<template>
    <div class="statis">
        <StatisView :album-id="albumId"/>
        <FeedsLine :album-id="albumId"/>
    </div>
</template>

<script>
    import FeedsLine from "./comps/FeedsLine";
    import StatisView from "./comps/StatisView";

    export default {
        name: "Statis",
        components: {FeedsLine, StatisView},
        data() {
            return {
                albumId: this.$route.params.id,
            }
        },
        computed: {
            width() {
                return this.$store.getters["layout/contentWidth"] - 30 - 640 - 15;
            }
        }
    }
</script>

<style scoped lang="less">
    .statis {
        height: 100%;
        padding: 15px;
        display: block;
    }
</style>
